const PRODUCTION = process.env.REACT_APP_MIDTRANS_IS_PRODUCTION === "true";
const SNAP_URL = PRODUCTION
  ? "https://app.midtrans.com/snap/snap.js"
  : "https://app.sandbox.midtrans.com/snap/snap.js";
const CLIENT_KEY = process.env.REACT_APP_MIDTRANS_CLIENT_KEY;

let snapPromise = null;

export function loadSnap() {
  if (window.snap) return Promise.resolve();
  if (snapPromise) return snapPromise;
  snapPromise = new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = SNAP_URL;
    script.setAttribute("data-client-key", CLIENT_KEY);
    script.onload = () => resolve();
    script.onerror = () => { snapPromise = null; reject(new Error("Gagal memuat Midtrans Snap")); };
    document.body.appendChild(script);
  });
  return snapPromise;
}
